import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { suspendCard } from "../../../services/api/banking/cards/suspendCard";
import { QUERY_CARD } from "../queries/useQueryCard";
import { QUERY_CARDS } from "../queries/useQueryCards";

export const useMutationSuspendCard = () =>
  useWSMutation<cardApiSpec.Card, WSServiceError, string>(suspendCard, {
    dependencies(response, cardId) {
      return [[QUERY_CARD, cardId], QUERY_CARDS];
    }
  });
